import React, { useState, useEffect } from 'react';
import { Search, Phone } from 'lucide-react';

const styles = {
  topBar: {
    background: 'var(--green-dark)',
    color: 'white',
    fontSize: '13px',
    padding: '6px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  topBarLink: {
    color: 'var(--orange-light)',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontWeight: 700,
  },
  nav: {
    background: 'white',
    boxShadow: '0 2px 16px rgba(26,92,46,0.10)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    transition: 'box-shadow 0.3s',
  },
  navInner: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
  },
  logoImg: {
    height: '52px',
    width: 'auto',
    objectFit: 'contain',
  },
  searchWrap: {
    flex: 1,
    position: 'relative',
    maxWidth: '480px',
  },
  searchInput: {
    width: '100%',
    padding: '10px 16px 10px 44px',
    border: '2px solid var(--green-border)',
    borderRadius: '50px',
    fontSize: '14px',
    fontFamily: 'var(--font-main)',
    background: 'var(--green-pale)',
    color: 'var(--gray-800)',
    outline: 'none',
    transition: 'border-color 0.2s, background 0.2s',
  },
  searchIcon: {
    position: 'absolute',
    left: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'var(--green-mid)',
    pointerEvents: 'none',
  },
};

export default function Navbar({ searchQuery, setSearchQuery }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top bar */}
      <div style={styles.topBar}>
        <span>🌿 Envíos a todo Chile · Despacho express disponible</span>
        <a href="https://wa.me/56912345678" style={styles.topBarLink} target="_blank" rel="noopener noreferrer">
          <Phone size={13} />
          WhatsApp: +56 9 1234 5678
        </a>
      </div>

      {/* Main nav */}
      <nav style={{ ...styles.nav, boxShadow: scrolled ? '0 4px 24px rgba(26,92,46,0.15)' : styles.nav.boxShadow }}>
        <div style={styles.navInner}>
          {/* Logo */}
          <div style={styles.logo}>
            <img src="/logo.png" alt="ShuCore.online" style={styles.logoImg} />
          </div>

          {/* Search */}
          <div style={styles.searchWrap}>
            <Search size={16} style={styles.searchIcon} />
            <input
              type="text"
              placeholder="Buscar productos..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={styles.searchInput}
              onFocus={e => {
                e.target.style.borderColor = 'var(--green-mid)';
                e.target.style.background = 'white';
              }}
              onBlur={e => {
                e.target.style.borderColor = 'var(--green-border)';
                e.target.style.background = 'var(--green-pale)';
              }}
            />
          </div>
        </div>
      </nav>
    </>
  );
}
